import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(undefined);

// Clave especial para saber si el usuario cambió idioma MANUALMENTE
const MANUAL_KEY = 'hacienda-lang-manual';

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState('en');

  // Al montar: detectar idioma inicial según región URL
  useEffect(() => {
    const savedManual = localStorage.getItem(MANUAL_KEY);
    const isUs = /^\/(us)(\/|$)/.test(window.location.pathname);

    if (savedManual) {
      // El usuario eligió idioma manualmente en algún momento → respetarlo
      setLangState(savedManual);
    } else if (isUs) {
      setLangState('en');
    } else {
      const browserLang = navigator.language.toLowerCase();
      setLangState(browserLang.startsWith('es') ? 'es' : 'en');
    }
  }, []);

  // Sincronizar idioma con región cuando el usuario cambia de región via SPA
  useEffect(() => {
    const onPopState = () => {
      // Solo auto-cambiar si NO hay preferencia manual guardada
      if (localStorage.getItem(MANUAL_KEY)) return;
      const isUs = /^\/(us)(\/|$)/.test(window.location.pathname);
      setLangState(isUs ? 'en' : (navigator.language.toLowerCase().startsWith('es') ? 'es' : 'en'));
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const setLang = (newLang) => {
    setLangState(newLang);
    // Marcar que el usuario eligió manualmente
    localStorage.setItem(MANUAL_KEY, newLang);
  };

  const t = (en, es) => (lang === 'es' ? es : en);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be inside LanguageProvider');
  return ctx;
}
